import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IRole, RoleTarget } from '@boma/administration-portal/shared/entities';
import { RolesService } from '@boma/administration-portal/shared/services';
import { BreadcrumbService } from '@boma/ui';
import {
  createRole,
  deleteRole,
  loadRoleDetails,
  loadRoles,
  setSelectedRole,
  updateRole,
} from '../../../+state/roles/roles.actions';
import { RolesFacade } from '../../../+state/roles/roles.facade';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'boma-users-roles-index',
  templateUrl: './users-roles-index.component.html',
  styleUrls: ['./users-roles-index.component.scss'],
})
export class UsersRolesIndexComponent implements OnInit {
  items: MenuItem[];

  activeItem: MenuItem;

  columns = [{ field: 'name', header: 'Name' }];
  roles$ = this.rolesFacade.allRoles$;
  loading$ = this.rolesFacade.loaded$;
  currentTarget = null;

  targetTypes: any[];
  permissionsList: any = [];

  createFormGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    description: new FormControl('', Validators.required),
    target: new FormControl('', Validators.required),
    permissions: new FormControl('', Validators.required),
  });

  updateFormGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    description: new FormControl('', Validators.required),
    target: new FormControl('', Validators.required),
    permissions: new FormControl('', Validators.required),
  });

  constructor(
    public rolesFacade: RolesFacade,
    private roleService: RolesService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumbService.setItems([{ label: 'Users - Roles' }]);
  }

  ngOnInit(): void {
    this.items = [
      {
        label: 'Boma Admin Permissions',
        icon: 'material-icons-outlined mi-admin-panel-settings',
        command: (event: any) => {
          this.handleTabChange({ index: 0 });
        },
      },
      {
        label: 'Entity Permissions',
        icon: 'material-icons-outlined mi-shield',
        command: (event: any) => {
          this.handleTabChange({ index: 1 });
        },
      },
    ];
    this.activeItem = this.items[0];
    this.targetTypes = Object.keys(RoleTarget)
      .filter((e) => isNaN(Number(e)))
      .map((value, key) => ({
        label: RoleTarget[key],
        value: RoleTarget[value],
      }));

    this.getTargetPermissions(0);
  }

  handleTabChange(e) {
    this.getTargetPermissions(e.index);

    switch (e.index) {
      case 0:
        this.permissionsList = [];
        this.rolesFacade.dispatch(loadRoles({ target: 'Administration' }));
        this.currentTarget = 'Administration';
        break;
      case 1:
        this.permissionsList = [];
        this.rolesFacade.dispatch(loadRoles({ target: 'Entity' }));
        this.currentTarget = 'Entity';
        break;
      default:
    }

    this.createFormGroup.patchValue({
      target: this.currentTarget,
    });

    this.updateFormGroup.patchValue({
      target: this.currentTarget,
    });
  }

  getTargetPermissions(value) {
    //replace with enum codes

    if (value === 'Administration' || value === '' || value === undefined) {
      value = 0;
    } else if (value === 'Entity') {
      value = 1;
    }
    var ctx = this;
    var label = this.targetTypes.filter((x) => x.value == value)[0].label;
    this.roleService.getTargetPermissions(label).subscribe({
      next(res) {
        if (typeof res != 'undefined') {
          ctx.permissionsList = res;
        }
      },
    });
  }

  onCreateSubmit() {
    this.rolesFacade.dispatch(
      createRole({ role: this.createFormGroup.value as IRole })
    );
    this.createFormGroup.reset();
  }

  handleUpdateSelection(data) {
    this.rolesFacade.dispatch(setSelectedRole({ roleId: data.id }));
    this.rolesFacade.dispatch(loadRoleDetails({ roleId: data.id }));
    let ctx = this;
    this.rolesFacade.selectedRoles$.subscribe({
      next(role) {
        if (typeof role != 'undefined' && role.permissions) {
          ctx.updateFormGroup.patchValue({ ...role });
          ctx.getTargetPermissions(role.target);
        }
      },
    });
  }

  changeContext(e) {
    console.log(e);
  }

  onUpdateSubmit() {
    const role = this.updateFormGroup.value as IRole;
    this.rolesFacade.dispatch(updateRole({ role: role }));
  }

  onItemDeleted(data) {
    this.rolesFacade.dispatch(deleteRole({ roleId: data.id }));
  }
}
